import React from "react";
import { useDispatch, useSelector } from "react-redux";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { Grid, Typography, Button } from "@material-ui/core";
import { BUTTON_COLOR, TEXT_COLOR } from "../utils/constant";
import {
  addToCart,
  addQuantity,
  subtractQuantity,
} from "../store/actions/cartActions";

const AddItemButton = function (props) {
  const {
    lineItem,
    setSelectedItem,
    setModifierPopup,
    setIsRepeatation,
    storeInfo, storeInfoConfig,
    isDisabled,
    setAction,
    isOutOfStock,
    isDesktop,
  } = props;

  const dispatch = useDispatch();
  const cartProps = useSelector((state) => state.cartReducer);

  let primaryColor = storeInfoConfig?.general_config?.primary_color;
  let secondaryColor = storeInfoConfig?.general_config?.secondary_color;

  const addQty = (item) => {
    dispatch(addQuantity(item));
  };

  const removeQty = (item) => {
    dispatch(subtractQuantity(item));
  };

  const addToCartItem = (item) => {
    dispatch(addToCart(item));
  };

  const handleAddButton = (item) => {
    setSelectedItem(item);
    if (
      item.item_variant?.length > 1 ||
      (item.item_variant[0]?.item_addons?.length &&
        !item.item_variant[0]?.item_addons.includes(""))
    ) {
      setModifierPopup(true);
    } else {
      addToCartItem(item);
    }
  };

  const getAddedItemQty = (id) => {
    const cartItem = cartProps?.addedItems?.filter((e) => e?._id === id);
    let q = 0;
    for (let i = 0; i < cartItem?.length; i++) {
      q = q + cartItem[i].quantity;
    }
    return q;
  };

  const checkAddedItem = (id) => {
    const cartItem = cartProps?.addedItems?.find((e) => e?._id === id);
    return cartItem ? true : false;
  };

  const matchingCartItems = cartProps?.addedItems?.filter((e) => e?._id === lineItem?._id) || [];
  const hasMultipleOrSpecial =
    matchingCartItems.length > 1 ||
    matchingCartItems.some((e) => e.specialRequest && e.specialRequest.trim() !== "");

  const showRepeatation =
    lineItem.item_variant?.length > 1 ||
    (lineItem.item_variant[0]?.item_addons?.length && !lineItem.item_variant[0]?.item_addons.includes("")) ||
    hasMultipleOrSpecial;

  return (checkAddedItem(lineItem?._id) && !isOutOfStock) ? (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", position: "relative" }}>
      <Grid
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          border: isDesktop ? `2px solid ${primaryColor || BUTTON_COLOR}` : "none",
          width: isDesktop ? "94px" : "9rem",
          minWidth: isDesktop ? "94px" : "9rem",
          height: isDesktop ? "34px" : "34px",
          borderRadius: isDesktop ? "3px" : "0.6rem",
          backgroundColor: primaryColor || BUTTON_COLOR,
          marginTop: isDesktop ? "0" : "2rem",
          boxShadow: isDesktop ? "none" : "0px 3px 6px rgba(0, 0, 0, 0.16)",
          boxSizing: "border-box",
        }}
      >
        <Grid item xs={4} style={{ display: "flex", justifyContent: "center" }}>
          <RemoveIcon
            style={{
              color: "white",
              backgroundColor: "transparent",
              height: isDesktop ? "20px" : "24px",
              width: isDesktop ? "20px" : "24px",
              borderRadius: isDesktop ? "3px 0 0 3px" : "0.6rem 0 0 0.6rem",
              cursor: "pointer",
            }}
            onClick={() =>
              showRepeatation
                ? (setIsRepeatation(true),
                  setSelectedItem(lineItem),
                  setAction(1))
                : removeQty(lineItem)
            }
          />
        </Grid>
        <Grid item xs={4} style={{ display: "flex", justifyContent: "center" }}>
          <Typography>
            <span
              style={{
                fontSize: isDesktop ? "18px" : "1.5rem",
                color: "white",
                fontWeight: isDesktop ? 600 : "700",
                fontFamily: "Satoshi, sans-serif",
              }}
            >
              {getAddedItemQty(lineItem?._id)}
            </span>
          </Typography>
        </Grid>
        <Grid item xs={4} style={{ display: "flex", justifyContent: "center" }}>
          <AddIcon
            style={{
              color: "white",
              backgroundColor: "transparent",
              height: isDesktop ? "20px" : "24px",
              width: isDesktop ? "20px" : "24px",
              borderRadius: isDesktop ? "0 3px 3px 0" : "0 0.6rem 0.6rem 0",
              opacity: isOutOfStock ? 0.5 : 1,
              cursor: isOutOfStock ? "not-allowed" : "pointer",
            }}
            onClick={() =>
              !isOutOfStock &&
              (showRepeatation
                ? (setIsRepeatation(true),
                  setSelectedItem(lineItem),
                  setAction(0))
                : getAddedItemQty(lineItem?._id)
                  ? addQty(lineItem)
                  : addToCartItem(lineItem))
            }
          />
        </Grid>
      </Grid>
      <div style={{ position: "absolute", top: "100%", marginTop: "2px", whiteSpace: "nowrap" }}>
        {(lineItem.item_variant?.length > 1 ||
          (lineItem.item_variant?.[0]?.item_addons?.length > 0 &&
            !lineItem.item_variant[0].item_addons.includes(""))) && !isOutOfStock && (
          <Typography>
            <span
              style={{
                fontSize: isDesktop ? "11px" : "0.875rem",
                fontWeight: "500",
                color: isDesktop ? "#888888" : "#212121",
                fontFamily: "Satoshi, sans-serif",
              }}
            >
              Customise
            </span>
          </Typography>
        )}
      </div>
    </div>
  ) : (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", position: "relative" }}>
      <Button
        disabled={isDisabled || isOutOfStock}
        onClick={() => handleAddButton(lineItem)}
        variant={isDesktop ? (isOutOfStock ? "contained" : "outlined") : "contained"}
        style={{
          float: isDesktop ? undefined : "right",
          width: isDesktop ? "94px" : "9rem",
          minWidth: isDesktop ? "94px" : "9rem",
          height: isDesktop ? (isOutOfStock ? "38px" : "34px") : (isOutOfStock ? "42px" : "34px"),
          padding: isOutOfStock ? "2px 4px" : "0",
          borderRadius: isDesktop ? "4px" : "0.6rem",
          fontSize: isDesktop ? "18px" : "16px",
          fontWeight: isDesktop ? 600 : 700,
          fontFamily: "Satoshi, sans-serif",
          backgroundColor: "white",
          color: isOutOfStock ? "#d32f2f" : (primaryColor || BUTTON_COLOR),
          border: isDesktop ? `1px solid ${isOutOfStock ? "#E5E5E5" : (primaryColor || BUTTON_COLOR)}` : "none",
          borderColor: isDesktop ? (isOutOfStock ? "#E5E5E5" : (primaryColor || BUTTON_COLOR)) : "transparent",
          cursor: isOutOfStock ? "not-allowed" : "pointer",
          opacity: 1,
          marginTop: isDesktop ? "0" : "2rem",
          boxShadow: isDesktop ? "none" : "0px 3px 6px rgba(0, 0, 0, 0.16)",
          textTransform: isDesktop ? "none" : undefined,
          boxSizing: "border-box",
        }}
      >
        {isOutOfStock ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              lineHeight: 1.15,
              color: "#d32f2f",
            }}
          >
            <span
              style={{
                fontSize: isDesktop ? "12px" : "1.05rem",
                fontWeight: 700,
                color: "#d32f2f",
                fontFamily: "Satoshi, sans-serif",
                lineHeight: 1.15,
              }}
            >
              Out Of
            </span>
            <span
              style={{
                fontSize: isDesktop ? "12px" : "1.05rem",
                fontWeight: 700,
                color: "#d32f2f",
                fontFamily: "Satoshi, sans-serif",
                lineHeight: 1.15,
              }}
            >
              Stock
            </span>
          </div>
        ) : (
          <span style={{ color: primaryColor || BUTTON_COLOR, fontWeight: 700, fontFamily: "Satoshi, sans-serif" }}>Add</span>
        )}
      </Button>
      <div style={{ position: "absolute", top: "100%", marginTop: "2px", whiteSpace: "nowrap" }}>
        {(lineItem.item_variant?.length > 1 ||
          (lineItem.item_variant?.[0]?.item_addons?.length > 0 &&
            !lineItem.item_variant[0].item_addons.includes(""))) && !isOutOfStock && (
          <Typography>
            <span
              style={{
                fontSize: isDesktop ? "11px" : "0.875rem",
                fontWeight: "500",
                color: isDesktop ? "#888888" : "#212121",
                fontFamily: "Satoshi, sans-serif",
              }}
            >
              Customise
            </span>
          </Typography>
        )}
      </div>
    </div>
  );
};

export default AddItemButton;
